// DS: CR18S
import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import { NotificationType } from '../../Notifications/redux/types';
import Notification from '../../Notifications/Notification';
import SystemNotification from '../../SystemNotification';
import AddToFaveIcon from '@wix/da-ds/pkg/Icons/24x24/AddedToFav';
import RemoveFaveIcon from '@wix/da-ds/pkg/Icons/24x24/RemovedFromFav';
import CheckIcon from '@wix/da-ds/pkg/Icons/Check';
import { getDeviationNotificationQueue } from '../../DeviationPage/redux/helpers';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { ResourceType } from '../../types/resource';
import { GallectionResourceType } from '../../types/gallection';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
const keys = {
    addOne: 'collectionPanel.notification.addedToCollection.v2',
    addMany: 'collectionPanel.notification.addedToCollection.multi.v2',
    removeOne: 'collectionPanel.notification.removedFromCollection.v2',
    removeSome: 'collectionPanel.notification.removedFromCollection.multi.v2',
    removeAll: 'collectionPanel.notification.removedFromAllCollections.v2',
    misc: 'collectionPanel.notification.miscChanges.v2',
    none: ''
};
const undoMap = {
    removeOne: 'addOne',
    removeSome: 'addMany',
    removeAll: 'addMany',
    addOne: 'removeOne',
    addMany: 'removeSome',
    misc: 'misc',
    none: 'none'
};
export const SCROLL_TO_FOLDER_HASH_SIGNAL = 'scrollIntoView';
export class CollectNotification extends React.Component {
    render() {
        const { id , collectedDeviation , queueName , addNotification  } = this.props;
        return /*#__PURE__*/ React.createElement(Notification, {
            id: id,
            queueName: queueName,
            cardComponent: SystemNotification,
            cardProps: {
                iconComponent: this.getIcon(),
                backgroundDeviation: collectedDeviation
            },
            onClose: queueName === getDeviationNotificationQueue(collectedDeviation) && !this.isUndo() ? ()=>addNotification(queueName, 'commentReminder', {}) : undefined
        }, this.renderTitle());
    }
    getIcon() {
        const { changeType  } = this.props;
        switch(changeType){
            case 'removeAll':
            case 'removeOne':
            case 'removeSome':
                return RemoveFaveIcon;
            case 'addMany':
            case 'addOne':
                return AddToFaveIcon;
            default:
                return CheckIcon;
        }
    }
    renderTitle() {
        const { changeType , changedFolderCount , t , exampleCollection , currentUser  } = this.props;
        const effectiveChange = this.isUndo() ? undoMap[changeType] : changeType;
        const key = keys[effectiveChange];
        if (!key || !currentUser) {
            return null;
        }
        switch(effectiveChange){
            case 'addOne':
            case 'removeOne':
                const collection = exampleCollection ? exampleCollection.name : t('collectionPanel.aCollection');
                const url = exampleCollection ? Url.userGalleryLink({
                    username: currentUser.username,
                    gallectionType: 'collection',
                    folderId: exampleCollection.folderId,
                    folderName: exampleCollection.name
                }) : Url.userGalleryLink({
                    username: currentUser.username,
                    gallectionType: 'collection'
                });
                var _exampleCollection_folderId;
                const biData = BiData({
                    evid: 100,
                    itemid: (_exampleCollection_folderId = exampleCollection === null || exampleCollection === void 0 ? void 0 : exampleCollection.folderId) !== null && _exampleCollection_folderId !== void 0 ? _exampleCollection_folderId : currentUser.userId,
                    typeid: exampleCollection ? GallectionResourceType.COLLECTION : ResourceType.USER,
                    sectionid: BiContextProvidedValue,
                    sectionname: BiContextProvidedValue,
                    section_typeid: BiContextProvidedValue,
                    sectiontype: BiContextProvidedValue,
                    widgetname: BiContextProvidedValue
                });
                return(// prettier-ignore
                /*#__PURE__*/ React.createElement(Trans, {
                    i18nKey: key
                }, "Changed in ", /*#__PURE__*/ React.createElement(BiLink, {
                    biData: biData,
                    href: `${url}#${SCROLL_TO_FOLDER_HASH_SIGNAL}`
                }, {
                    collection
                })));
            default:
                return t(key, {
                    changedFolderCount
                });
        }
    }
    isUndo() {
        return this.props.type === NotificationType.CollectUndo;
    }
    constructor(...args){
        super(...args);
        this.onUndo = ()=>{
            const { collectedDeviation: { deviationId  } , onUndo , removeNotification , id  } = this.props;
            onUndo(deviationId);
            removeNotification(id);
        };
    }
}
export default withTranslation()(CollectNotification);
